import React from "react";

const OrderStatusAnalytics = () => {
  const statuses = ["PENDING", "PROCESSING", "COMPLETED", "CANCELLED"];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Order Status Overview</h2>
      <ul className="space-y-2">
        {statuses.map((status) => (
          <li
            key={status}
            className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-md shadow-sm font-medium"
          >
            {status}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OrderStatusAnalytics;
